if (!customElements.get("collection-list")) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.container = this.querySelector(".js-collection-list-container");
      this.sidebar = this.querySelector(".js-collection-list-sidebar");
      this.sidebarCollectionLinksWrap = this.querySelector(".js-sidebar-collection-links");
      this.alphabetic = this.dataset.alphabetic === "true";

      const allElements = Array.from(
        document.querySelectorAll(".section-collection-list .collection_list__item")
      );

      const groupedElements = this.groupBySubtitles(allElements);
      this.moveGroupsToMainFrame(groupedElements);

      const allContainers = document.querySelectorAll(".section-collection-list");
      this.deleteContainers(allContainers);

      document.querySelector("main")?.append(this);
    }

    /**
     * Groups collections under the nearest preceding subtitle, or treats all as one group if no subtitles exist.
     */
    groupBySubtitles(elements) {
      let groups = [];
      let currentGroup = [];

      let hasSubtitles = elements.some((el) => el.matches(".collection_list__subtitle")); // Adjust selector as needed

      elements.forEach((el) => {
        if (el.matches(".collection_list__subtitle")) {
          if (currentGroup.length) groups.push(currentGroup);
          currentGroup = [el]; // Start new group with subtitle
        } else {
          currentGroup.push(el);
        }
      });

      if (currentGroup.length) groups.push(currentGroup);

      // If no subtitles exist, merge everything into one group
      if (!hasSubtitles) {
        return [elements]; // Treat all collections as a single sortable group
      }

      return groups;
    }

    /**
     * Sorts each group (except subtitles) and appends to the main container.
     */
    moveGroupsToMainFrame(groups) {
      groups.forEach((group) => {
        const [firstElement, ...rest] = group;

        // If the first element is a subtitle, append it first
        if (firstElement.matches && firstElement.matches(".collection_list__subtitle")) {
          this.container.append(firstElement);
        } else {
          rest.push(firstElement);
        }

        // Sort collections (skip subtitle if present)
        const sortedCollections = this.alphabetic
          ? rest.sort((a, b) => {
              const textA = a.querySelector(".card__title .card-link")?.textContent.toLowerCase();
              const textB = b.querySelector(".card__title .card-link")?.textContent.toLowerCase();
              return textA?.localeCompare(textB) ?? 0;
            })
          : rest;

        sortedCollections.forEach((collection) => {
          this.container.append(collection);
          this.addToSidebar(collection);
        });
      });
    }

    /**
     * Adds collection links to the sidebar.
     */
    addToSidebar(collection) {
      if (!this.sidebarCollectionLinksWrap) return;

      const href = collection.querySelector(".card__title .card-link")?.href;
      const text = collection.querySelector(".card__title .card-link")?.textContent;

      const linkEle = document.createElement("p");
      linkEle.className = "mb-3";
      linkEle.innerHTML = `
        <a href="${href}" class="sidebar-link text-current">
          ${text}
        </a>
      `;

      this.sidebarCollectionLinksWrap.append(linkEle);
    }

    deleteContainers(containers) {
      containers.forEach((container) => container.remove());
    }
  }

  customElements.define("collection-list", CollectionList);
}
